<!-- 修改原始平台单号 -->
<template>
  <div class="cus-modal">
    <OmsForm :form-config="formConfig" />
    <OmsButton :btn-config="btnConfig" class="modal-footer"/>
  </div>
</template>

<script>
export default {
  props: {
    componentData: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      formConfig: {
        formValue: {
          originalTid: '',
        },
        formData: [
          {
            style: 'input',
            label: t('原始平台单号'), // 输入框前文字
            value: 'originalTid',
            width: '24',
          }
        ]
      },
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: t('取消'),
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }, // 按钮点击事件
          },
          {
            type: 'primary',
            text: t('确定'),
            btnclick: () => {
              this.save();
            }, // 按钮点击事件
          }
        ],
      },
    };
  },
  methods: {
    save() {
      if (this.formConfig.formValue.originalTid == '') return this.$Message.warning(t('请输入原始平台单号'));
      const params = {
        id: this.componentData.id,
        ...this.formConfig.formValue
      };
      this.service.common.publicUrlParams('/api/cs/oc/oms/v1/handleOriginalTid', params).then(res => {
        if (res.data.code == 0) {
          this.$Message.success(res.data.message);
          if (this.$route.params.customizedModuleId == 2627) {
            this.$parent.$parent.$parent.loadData();
          } else {
            this.$parent.$parent.$parent.load();
          }
          this.$parent.$parent.closeConfirm();
        }
      })
    }
  },
};
</script>